module.exports = __webpack_public_path__ + "static/media/ApercuPro-Regular.a69431b4.woff";